<template>
  <el-form :rules="rules" :model="resetForm" ref="resetForm" class="reset-container" label-position="left" label-width="0px" v-loading="loading">
    <h3 class="reset">{{$t("reset.title")}}</h3>
    <el-form-item prop="username">
      <el-input type="text" v-model="resetForm.username" auto-complete="off" :placeholder="$t('reset.username')">
      </el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input type="password" v-model="resetForm.password" auto-complete="off" :placeholder="$t('reset.password')">
      </el-input>
    </el-form-item>
    <el-form-item prop="password2">
      <el-input type="password" v-model="resetForm.password2" auto-complete="off" :placeholder="$t('reset.confirm')">
      </el-input>
    </el-form-item>

    <el-form-item style="width: 100%">
      <el-button type="primary" @click="submitClick('resetForm')" style="width: 100%">{{$t("reset.button")}}
      </el-button>
    </el-form-item>
    <el-button class="el-icon-caret-left" type="text" @click="jump('/')">{{$t("reset.return_login")}}</el-button>
  </el-form>
</template>
<script>
import {
  postRequest
} from "../utils/api";
import {
  putRequest
} from "../utils/api";
import {
  isIntersect
} from "../utils/utils";
export default {
  data() {
    return {
      rules: {
        username: [{
          required: true,
          message: this.$t("reset.usernameRule"),
          trigger: "blur"
        },
        {
          pattern: /^[A-Za-z0-9_]+$/,
          message: this.$t("register.usernamePattern"),
        },
        ],
        password: [{
          required: true,
          message: this.$t("reset.passwordRule"),
          trigger: "blur"
        },
        {
          pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[])+$)([^(0-9a-zA-Z)]|[]|[a-zA-Z]|[0-9]){6,}$/,
          message: this.$t("reset.passwordPattern")
        }
        ],
        password2: [{
          required: true,
          message: this.$t("reset.confirm"),
          trigger: "blur"
        },
          // {
          //   pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[])+$)([^(0-9a-zA-Z)]|[]|[a-zA-Z]|[0-9]){6,}$/,
          //   message: this.$t("reset.passwordPattern")
          // }
        ]
      },
      checked: true,
      resetForm: {
        username: "",
        password: "",
        password2: ""
      },
      loading: false
    };
  },
  methods: {
    jump(path) {
      this.$router.replace(path);
    },
    clearAllCookie() {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--;)
          document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
      }
    },
    submitClick(resetForm) {
      var str = window.location.href;
      var email = str.split("https://www.hrbox.jp/senseSys/#/passwordReset?email=")[1];
      // var email = str.split("http://localhost:8080/#/passwordReset?email=")[1];
      email = email.replace("%40", "@");
      this.$refs[resetForm].validate((valid) => {
        if (valid) {
          var _this = this;
          this.loading = true;
          if (this.resetForm.password == this.resetForm.password2) {
            postRequest("/submitReset", {
              username: this.resetForm.username,
              password: this.resetForm.password,
              email: email

              // email: document.cookie.substring(6)
              //截取从cookie中拿到的邮箱字符串cookie键值对。document.cookie是cookie1=value的形式

              // email: this.$route.query.email,
            }).then(
              resp => {
                _this.loading = false;

                if (resp.status == 200) {
                  //成功
                  var json = resp.data;
                  if (json.status == "success") {
                    _this.$i18n.locale = json.locale;

                    _this.$alert(
                      this.$t("reset.reset_completed"),
                      this.$t("reset.success")
                    );
                    // _this.clearAllCookie();

                    _this.$router.replace({
                      path: "/"
                    });
                  } else if (json.status == "usernameError") {
                    _this.$alert(
                      this.$t("reset.usernameError"),
                      this.$t("reset.fail")
                    );
                  } else {
                    _this.$alert(this.$t("reset.reset_failed"), this.$t("reset.fail"));
                  }
                } else {
                  //失敗
                  _this.$alert(this.$t("reset.reset_failed"), this.$t("reset.fail"));
                }
              },
              resp => {
                _this.loading = false;
                _this.$alert(this.$t("reset.server_not_found"), this.$t("reset.fail"));
              }
            );
          } else {
            _this.loading = false;
            _this.$alert(this.$t("reset.password_not_same"), this.$t("reset.fail"));
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
.reset-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}

.reset_title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
</style>


// WEBPACK FOOTER //
// src/components/PasswordReset.vue